import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import SettingsPage from 'flarum/forum/components/SettingsPage';
import FieldSet from 'flarum/common/components/FieldSet';
import Button from 'flarum/common/components/Button';

// Member signature: a short plain-text line (e.g. "2026 J7 PHEV") shown under
// each of their posts, so readers know which model a post is about.
export default function addSignatures() {
  extend(CommentPost.prototype, 'footerItems', function (items) {
    const user = this.attrs.post && this.attrs.post.user();
    const sig = user && user.attribute('signature');
    if (!sig) return;
    items.add('jaecoo-signature', <div className="Post-signature">{sig}</div>, -10);
  });

  extend(SettingsPage.prototype, 'settingsItems', function (items) {
    const user = this.user;
    if (!user) return;
    if (this.signatureValue === undefined) this.signatureValue = user.attribute('signature') || '';

    items.add(
      'signature',
      <FieldSet className="Settings-signature" label={app.translator.trans('jaecoo-translate.forum.signature_label')}>
        <p className="helpText">{app.translator.trans('jaecoo-translate.forum.signature_help')}</p>
        <input
          className="FormControl"
          type="text"
          maxlength="100"
          placeholder={app.translator.trans('jaecoo-translate.forum.signature_placeholder')}
          value={this.signatureValue}
          oninput={(e) => (this.signatureValue = e.target.value)}
        />
        <Button
          className="Button Button--primary"
          loading={this.signatureLoading}
          onclick={() => {
            this.signatureLoading = true;
            user
              .save({ signature: this.signatureValue })
              .then(() => {
                this.signatureValue = user.attribute('signature') || '';
                app.alerts.show({ type: 'success' }, app.translator.trans('jaecoo-translate.forum.signature_saved'));
              })
              .catch(() => {})
              .then(() => {
                this.signatureLoading = false;
                m.redraw();
              });
          }}
        >
          {app.translator.trans('jaecoo-translate.forum.signature_save')}
        </Button>
      </FieldSet>,
      -5
    );
  });
}
